'use client';

export { default } from '../error';
